export default __webpack_public_path__ + "static/14-92f2ea205e2a4b6ebf6dff3128e80eab.gif";